module.exports = __webpack_public_path__ + "img/oneid-1.19319cd9.png";